export default __webpack_public_path__ + "static/media/ac5899ea3d6b384c372712aae6c9832d.svg";